import { MultiStepWizard } from '../MultiStepWizard/MultiStepWizard'
import { MultiStepTwitterPlanningSchema } from '../schemas/TwitterPlanning'
import { MultiStepTwitterPlanningWizardProps } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ASPECT_RATIOS, DesignChannel } from 'components/NewFileModal/Types'
import { ChooseTopic } from '../PlanningWizard/ChooseTopic/ChooseTopic'
import { SelectCaptions } from '../PlanningWizard/SelectCaptions/SelectCaptions'
import { PlanContent } from '../PlanningWizard/PlanContent/PlanContent'
import { ContentPlanningProvider, useContentPlanningContext } from '../PlanningWizard/ContentPlanningContext'
import { useState } from 'react'
import { MediaType } from '../schemas/shared/mediaType'

const MultiStepTwitterPlanningWizard = (
  props: MultiStepTwitterPlanningWizardProps & {
    mediaType: MediaType
    setMediaType: (mediaType: MediaType) => void
  },
) => {
  const { generateCampaign } = useContentPlanningContext()
  const { width, height } = ASPECT_RATIOS['twitter-post']
  const { mediaType, setMediaType } = props

  return (
    <MultiStepWizard.Root
      {...props}
      schema={MultiStepTwitterPlanningSchema}
      onSubmit={generateCampaign}
      initialValues={{
        ...props.initialValues,
        media_type: mediaType,
        width,
        height,
        source_visual_element_ids: props.initialValues?.source_visual_element_ids || [],
      }}
    >
      <ChooseTopic
        header="Enter a Topic for Your X/Twitter Posts"
        subHeader="Blaze will help you write and schedule a cluster of content around this topic linked to a Blaze campaign for easy reference."
        onChange={(values) => setMediaType(values.media_type)}
      />
      <SelectCaptions
        header="Select X/Twitter Posts"
        subHeader="Select posts related to your topic. You can edit them directly on this page."
        inputPlaceholder="Write your own post..."
        nextLabel={() => 'Plan'}
      />
      <PlanContent
        header="Plan Your X Calendar"
        subHeader="Select a date and time for each of your posts or have Blaze pick for you."
        externalIntegrationType={ExternalIntegrationEnum.X}
        previousLabel={mediaType === 'design' ? 'Templates' : 'Posts'}
      />
    </MultiStepWizard.Root>
  )
}

const MultiStepTwitterPlanningWizardContainer = (props: MultiStepTwitterPlanningWizardProps) => {
  const [mediaType, setMediaType] = useState(props.initialValues?.media_type || MediaType.DocumentWithImages)

  return (
    <ContentPlanningProvider
      captionsGenerationType={ChannelType.Tweets}
      generationType={mediaType === MediaType.Design ? DesignChannel.TwitterPost : ChannelType.Tweets}
      initialValues={props.initialValues}
    >
      <MultiStepTwitterPlanningWizard {...props} mediaType={mediaType} setMediaType={setMediaType} />
    </ContentPlanningProvider>
  )
}

export { MultiStepTwitterPlanningWizardContainer as MultiStepTwitterPlanningWizard }
